import Vue from 'vue'
import VueGtm from '@gtm-support/vue2-gtm'

Vue.use(VueGtm, {
  id: [], 
  defer: false,
  compatibility: false,
  enabled: true,
  debug: true,
  loadScript: false, 
  trackOnNextTick: false,
})